module.exports = __webpack_public_path__ + "img/bnr_lesson_sp.0bfa6f7c.png";